import posthog from 'posthog-js';

// No key (e.g. local dev) → posthog stays a silent no-op.
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    defaults: '2026-05-30', // SPA pageviews/pageleaves on route change
    person_profiles: 'identified_only', // anonymous visitors don't burn person profiles
    capture_exceptions: true, // auto-capture uncaught JS errors + unhandled rejections
    enable_recording_console_log: true, // console.error/warn show up inside session replays
    session_recording: {
      maskAllInputs: true,
    },
  });
}

export default posthog;
